/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'

export const OrderList = () => {
	return <View css={style}></View>
}

export default OrderList

const style = css({
	overflow: 'auto',
	height: '100%',
	width: '100%',
	padding: '0.5rem 1rem',

	orderListView: {},
})
